export default {
  header: 'Hi,',
  title: 'Are you sure you want to cancel your booking {{tripId}}?',
  btnActions: {
    positive: 'Yes',
    negative: 'No',
  },
  tripNothingChangedMessage: 'Thank you and see you soon!',
  tripCancelResultMessage: 'Your booking {{tripId}} has been canceled successfully',
  errorCancelTripAlert: 'Unfortunately, you cannot cancel your reservation as the requested pickup time has already passed.',
};